
import { configureStore, combineReducers } from "@reduxjs/toolkit"
import userReducer from "store/slices/userSlice";

import certificationReducer from "store/slices/newCertificationSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { apiSlice } from "store/services/apiSlice";
import { ghgApiSlice } from "store/services/ghgApiSlice";
import certificateReducer from "store/slices/certificationSlice";
 

const rootReducer = combineReducers({
    user:  userReducer,
    // "modules-available": modulesReducer,
    "certification": certificationReducer,
    // "polyhouse": polyHouseReducer,
    // "customize-ui": customizationReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [ghgApiSlice.reducerPath]: ghgApiSlice.reducer,
    certificate : certificateReducer,
});

const persistConfig = {
    key: 'user',
    storage,
    version: 1,
    whitelist: ['user','certificate'] // Only store the auth state.
}

const persistedReducers = persistReducer(persistConfig, rootReducer);

const userStore = configureStore({
    reducer: persistedReducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Disable serializableCheck for RTK Query
        }).concat(apiSlice.middleware, ghgApiSlice.middleware), 

});

export const persistor = persistStore(userStore);
export default userStore;
